import React from "react";
import Text from "@amzn/meridian/text";
import { useBundle } from "@amzn/react-arb-tools";
import { HOMEPAGE_MESSAGE_BUNDLE_NAME } from "../../../constants";
import { t } from "../../../helpers";

const AllegroIsHereText = ({ fontType }) => {
  const [bundle] = useBundle(HOMEPAGE_MESSAGE_BUNDLE_NAME);

  return (
    <React.Fragment>
      <Text type={fontType} fontFamily={"bookerly"}>
        {t(bundle, "listen_while_you_walk_title")}
      </Text>
      <Text type={"b300"} fontFamily={"amazonEmber"}>
        {t(bundle, "listen_while_you_walk_paragraph_first")}
      </Text>
      <Text type={"b300"} fontFamily={"amazonEmber"}>
        {t(bundle, "listen_while_you_walk_paragraph_second")}
      </Text>
    </React.Fragment>
  );
};

export default AllegroIsHereText;
